enum SubEntityType {
  TIRE = 'tire',
  BRAKE = 'brake',
  DIAGNOSTIC = 'diagnosticStep',
}

export default SubEntityType;